"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";

// Helper function to create simple SVG icons (can be replaced with actual icons)
// If you have a more central icon library, consider moving this or using existing icons.
const PlaceholderIcon = ({ className }: { className?: string }) => (
  <svg
    className={className || "h-12 w-12 text-primary"}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const MatchFilterOptions = () => {
  const [selectedStyle, setSelectedStyle] = useState<string>("Competitive");
  const [selectedSkill, setSelectedSkill] = useState<string>("Similar");
  const [selectedHandicap, setSelectedHandicap] = useState<string>("Any");

  const playingStyles = ["Relaxed", "Competitive", "Social", "Focused"];
  const skillLevels = ["Any", "Similar"];
  const handicapOptions = ["Any", "Specify Range"];

  return (
    <div className="mt-4 p-4 border border-border rounded-lg bg-background shadow-sm w-full">
      <div className="space-y-4">
        {/* Playing Style Selection */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-1">
            Preferred Playing Style:
          </label>
          <div className="grid grid-cols-2 gap-2">
            {playingStyles.map((style) => (
              <Button
                key={style}
                variant={selectedStyle === style ? "default" : "outline"}
                size="sm"
                onClick={() => setSelectedStyle(style)}
              >
                {style}
              </Button>
            ))}
          </div>
        </div>

        {/* Skill Level Selection */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-1">
            Skill Level:
          </label>
          <div className="flex space-x-2">
            {skillLevels.map((level) => (
              <Button
                key={level}
                variant={selectedSkill === level ? "default" : "outline"}
                size="sm"
                className="flex-1"
                onClick={() => setSelectedSkill(level)}
              >
                {level}
              </Button>
            ))}
          </div>
        </div>

        {/* Handicap Consideration (Simplified) */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-1">
            Handicap:
          </label>
          <div className="flex items-center space-x-2">
            {handicapOptions.map((option) => (
              <Button
                key={option}
                variant={selectedHandicap === option ? "default" : "outline"}
                size="sm"
                className="flex-1"
                onClick={() => setSelectedHandicap(option)}
              >
                {option}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-3 mb-3 text-center">
        Illustrative: More filters available in-app!
      </p>

      {/* Action Buttons */}
      <div className="mt-4 pt-4 border-t border-border space-y-2 sm:space-y-0 sm:flex sm:space-x-2">
        <Button size="sm" className="w-full sm:flex-1">
          Find Match Now
        </Button>
        <Button variant="outline" size="sm" className="w-full sm:flex-1">
          Schedule Match{" "}
        </Button>
      </div>
    </div>
  );
};
